/**
 * Query key factories for toolkit collection data.
 * Consumers pass a scope record (e.g. { organizationId, projectId })
 * to produce unique cache keys per context.
 */
export type ToolkitCollectionQueryScope = Record<
  string,
  string | null | undefined
>;

function normalizeScope(scope: ToolkitCollectionQueryScope) {
  return Object.fromEntries(
    Object.entries(scope)
      .filter(([, value]) => value != null && value !== "")
      .sort(([left], [right]) => left.localeCompare(right))
  );
}

export const toolkitCollectionKeys = {
  all: (scope: ToolkitCollectionQueryScope = {}) =>
    ["toolkit_collection", normalizeScope(scope)] as const,

  collection: (scope: ToolkitCollectionQueryScope = {}) =>
    [...toolkitCollectionKeys.all(scope)] as const,
};
